import SharedInlineHtml from '@cx-web/components/page-template/InlineHtml';
import { type MyOCData } from '@cx-web/domain-types/myoc';
import { useAuthModal } from '@cx-web/feature-myoc-login-2018/provider';
import { VIEW_LOGIN, VIEW_SIGNUP } from '@cx-web/feature-myoc-login-2018/store';
import { useUIConfig } from '@cx-web/ui-shell/ui-config-context';

// RR7 atlas glue for the shared INLINE_HTML. The component (incl. the premium login wall) lives once in
// `@cx-web/components/page-template/InlineHtml` (shared with atlas-astro); this glue resolves the RR7
// request context — `isLoggedIn` from MyOC data, `resourcesUrl` from UIConfig — and wires the login-wall
// CTAs to RR7's auth modal (`useAuthModal().openAtView`). The shared component imports no auth/runtime
// package, so it stays free of the components→auth-ui dependency cycle; the auth wiring is glue.
export default function InlineHtml({
  componentTags,
  html,
  myocData,
}: {
  componentTags?: string[];
  currentPathWithRepub?: string;
  html: string;
  myocData: MyOCData;
  repub?: string;
}) {
  const { resourcesUrl } = useUIConfig();
  const { openAtView } = useAuthModal();

  return (
    <SharedInlineHtml
      componentTags={componentTags}
      html={html}
      isLoggedIn={!!myocData.myOCUser}
      onLogin={() => openAtView(VIEW_LOGIN)}
      onSignup={() => openAtView(VIEW_SIGNUP)}
      resourcesUrl={resourcesUrl}
    />
  );
}
